export const JOB_PHASE_NOTES_MIN_LENGTH = 1;
export const JOB_PHASE_NOTES_MAX_LENGTH = 500;
